import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { V_IOTBOX_SETTING_ITEM } from './IoTBoxSetting';
import { useTranslation } from 'react-i18next';
import { IoTBoxSettingStyle } from './IoTBoxSettingStyle';

/**
 * IoTBox設定 フッターボタン
 */
type Props = {
  items: V_IOTBOX_SETTING_ITEM[];
  onClickUpdateScreenButton: () => void;
  onClickAllDLButton: () => void;
  onClickNewButton: () => void;
  onClickDelButton: () => void;
};

const IoTBoxSettingFooter: React.FC<Props> = (props) => {
  //const [imsiNo, setImsiNo] = useState<string>('');
  const pageStyle = IoTBoxSettingStyle();
  const { t } = useTranslation();

  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickUpdateScreenButton()}
        >
          {t('IoTBoxSettingFooter.画面更新', '画面更新')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          disabled={props.items.every((item) => !item.DL_ENABLE)}
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => {
            props.onClickAllDLButton();
          }}
        >
          {t('IoTBoxSettingFooter.一括設定ファイルDL', '一括設定ファイルDL')}
        </Button>
      </Grid>

      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => {
            props.onClickNewButton(/* imsiNo */);
          }}
        >
          {t('IoTBoxSettingFooter.新規登録', '新規登録')}
        </Button>
      </Grid>

      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickDelButton(/* imsiNo */)}
        >
          {t('IoTBoxSettingFooter.削除', '削除')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default IoTBoxSettingFooter;
